import { RadioInputComponent } from './radio.input.component'

export class DropdownInputComponent extends RadioInputComponent {
  // TODO: move initialization and reset logic here
}
